export default __webpack_public_path__ + "static/media/my-image.42104e9f.jpg";